const adNexusChannels = ['470', '471'];

// TODO: enable tracking in Test env if we have a test env config for adNexus!
const adNexusApproved = () => {
  if (
    typeof window !== 'undefined' &&
    'https://rocker.com' === window.location.origin
  ) {
    const channel = localStorage.getItem('channel');
    if (adNexusChannels.indexOf(channel) !== -1) {
      document.createElement('img').src =
        'https://secure.adnxs.com/px?id=984561&t=2';
    }
  }
};

// We would never want to throw an exception that could interfer with the application process
// for something like this. We would like to send it off to sentry which we do in catch.
const trackWithCatchAll = fn => {
  const isProductionOrTest =
    typeof window !== 'undefined' &&
    ['https://rocker.com', 'https://test.rocker.com'].includes(
      window.location.origin,
    );
  // We have a test config for Segment - see the .env.example
  if (!isProductionOrTest) return;
  try {
    fn();
  } catch (e) {
    window.Raven && window.Raven.captureException(e);
  }
};

const applied = () => {
  window.analytics.track('Event1');
};

export const approved = () => {
  trackWithCatchAll(() => {
    applied();
    adNexusApproved();
    window.analytics.track('Event2');
  });
};

export const denied = () => {
  trackWithCatchAll(() => {
    applied();
    window.analytics.track('Event3');
  });
};

export const signed = () => {
  trackWithCatchAll(() => {
    window.analytics.track('Event4');
    if (window && window.analytics) {
      window.analytics.track('signed');
    }
  });
};

export const accountCreditApproved = ssn_id => {
  trackWithCatchAll(() => {
    window.analytics.track('Account Credit Applied', { ssn_id });
    window.analytics.track('Account Credit Approved', { ssn_id });
  });
};

export const accountCreditDenied = ssn_id => {
  trackWithCatchAll(() => {
    window.analytics.track('Account Credit Applied', { ssn_id });
    window.analytics.track('Account Credit Denied', { ssn_id });
  });
};

export const accountCreditSigned = () => {
  trackWithCatchAll(() => {
    window.analytics.track('accountCreditSigned');
  });
};

export const cardSignup = () => {
  trackWithCatchAll(() => {
    window.analytics.track('appLinkSmsSent');
    const isCard = window.location.pathname.startsWith('/kort');

    if (isCard) {
      window.analytics.track('cardSignup');
    }
  });
};

export const appBadgeDeepLinkClicked = (badge_type, deeplink_url) => {
  trackWithCatchAll(() => {
    window.analytics.track('App Badge Deeplink Clicked', {
      badge_type,
      deeplink_url,
    });
  });
};

export const appliedWithPriceGuarantee = () => {
  trackWithCatchAll(() => {
    window.analytics.track('priceGuaranteeApplied');
  });
};

export const carLoanApplicationSent = (loan_amount, email_id) => {
  trackWithCatchAll(() => {
    window.analytics.track('Car Loan Application Sent', {
      loan_amount,
      email_id,
    });
  });
};
export const accountCreditApplyStart = () => {
  trackWithCatchAll(() => {
    window.analytics.track('Account Credit Form Opened');
  });
};
export const accountCreditSubmitting = ssn_id => {
  trackWithCatchAll(() => {
    window.analytics.track('Account Credit Submitting Form', { ssn_id });
  });
};

export function loanBrokerApplied(application_id, applied_amount) {
  trackWithCatchAll(() => {
    window.analytics.track('Web Broker Loan Applied', {
      application_id,
      applied_amount,
    });
  });
}

export const loanBrokerInitiated = (
  stepId,
  stepName,
  reason = 'stepReached',
) => {
  trackWithCatchAll(() => {
    window.analytics.track('Web Broker Loan Initiated', {
      reason,
      step_name: stepName,
      step_id: stepId,
    });
  });
};

export const loanPredictionEngagement = (
  user_id,
  engagement_type,
  updated_value,
  likelihood = null,
  min_interest_rate = null,
  max_interest_rate = null,
) => {
  trackWithCatchAll(() => {
    window.analytics.track('Web Loan Prediction Engaged', {
      user_id,
      engagement_type,
      updated_value,
      likelihood,
      min_interest_rate,
      max_interest_rate,
    });
  });
};
